import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Hasło zostało zmienione. Zaloguj się.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Ustaw nowe hasło" subtitle="Wprowadź nowe hasło do swojego konta">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label htmlFor="password">Nowe hasło</Label>
          <Input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1.5" />
        </div>
        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="reset-error">{error}</p>}
        <Button type="submit" disabled={loading || !token} className="w-full bg-ztk-blue hover:bg-ztk-navy800" data-testid="reset-submit">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Zmień hasło
        </Button>
        <p className="text-center text-sm text-muted-foreground">
          <Link to="/login" className="text-ztk-blue hover:underline">Powrót do logowania</Link>
        </p>
      </form>
    </AuthShell>
  );
}
